// extracted by mini-css-extract-plugin
export default {"container":"carousel_container__76DRt","prevArrow":"carousel_prevArrow__Nf0tF","nextArrow":"carousel_nextArrow__Z9jhM"};